function getAllOrderStatus(_this) {
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/getAllOrderStatus',
      url: Vue.prototype.api + 'api/local/getAllOrderStatus',
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          _this.pageData.listOrderStatus = response.data.data
          let status = _this.pageData.listOrderStatus.find(
            (item) => item.id == _this.pageData.orderform.orderstatus_id
          )
          _this.pageData.currentStatusPri = status.priority
          _this.pageData.currrntStatusName = status.name_done_en

          for (let item of _this.pageData.listOrderStatus) {
            let timestampTmp = ''
            for (let record of _this.pageData.listOrderRecords) {
              if (record.orderstatus_id == item.id) {
                timestampTmp = record.create_time
              }
            }

            if (
              item.priority - _this.pageData.currentStatusPri > 0 &&
              item.priority - _this.pageData.currentStatusPri != 1
            ) {
              item.icon = 'el-icon-more'
              item.type = 'info'
            } else if (item.priority - _this.pageData.currentStatusPri == 1) {
              item.icon = 'el-icon-refresh'
              item.type = 'primary'
            } else {
              item.icon = 'el-icon-check'
              item.type = 'success'
              item.timestamp = timestampTmp
            }
          }

          if (Number(_this.pageData.currentStatusPri) > 4) {
            _this.pageData.listDeliveryCurrent =
              _this.pageData.orderform.listDelivery
          }

          if (_this.pageData.listDeliveryCurrent.length != 0) {
            _this.pageData.listDeliveryDisplay = []
            for (let index in _this.pageData.listDeliveryCurrent) {
              if (index == 0) {
                let obj = {}
                obj.logistics_no =
                  _this.pageData.listDeliveryCurrent[index].logistics_no
                obj.logistics_company =
                  _this.pageData.listDeliveryCurrent[index].logistics_company
                obj.create_time =
                  _this.pageData.listDeliveryCurrent[index].create_time
                obj.products = []
                let obj2 = {}
                obj2.product_id =
                  _this.pageData.listDeliveryCurrent[index].product_id
                obj2.product_name =
                  _this.pageData.listDeliveryCurrent[index].product_name
                obj2.quantity =
                  _this.pageData.listDeliveryCurrent[index].quantity
                obj.products.push(obj2)
                _this.pageData.listDeliveryDisplay.push(obj)
              } else {
                let count = 0
                for (let item of _this.pageData.listDeliveryDisplay) {
                  if (
                    _this.pageData.listDeliveryCurrent[index].logistics_no ==
                    item.logistics_no
                  ) {
                    let existProduct = {}
                    existProduct.product_id =
                      _this.pageData.listDeliveryCurrent[index].product_id
                    existProduct.product_name =
                      _this.pageData.listDeliveryCurrent[index].product_name
                    existProduct.quantity =
                      _this.pageData.listDeliveryCurrent[index].quantity
                    item.products.push(existProduct)
                  } else {
                    count++
                  }
                }
                if (count == _this.pageData.listDeliveryDisplay.length) {
                  let obj = {}
                  obj.logistics_no =
                    _this.pageData.listDeliveryCurrent[index].logistics_no
                  obj.logistics_company =
                    _this.pageData.listDeliveryCurrent[index].logistics_company
                  obj.create_time =
                    _this.pageData.listDeliveryCurrent[index].create_time
                  obj.products = []
                  let obj2 = {}
                  obj2.product_id =
                    _this.pageData.listDeliveryCurrent[index].product_id
                  obj2.product_name =
                    _this.pageData.listDeliveryCurrent[index].product_name
                  obj2.quantity =
                    _this.pageData.listDeliveryCurrent[index].quantity
                  obj.products.push(obj2)
                  _this.pageData.listDeliveryDisplay.push(obj)
                }
              }
            }
          }

          getShipping(_this, _this.pageData.orderform.shippingaddress)

          return
        } else if (response.data.code == '210') {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_entitiesept'),
          })
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function getOrderFiles(_this, orderid) {
  let order = {}
  order.id = orderid

  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/queryOrderFiles',
      url: Vue.prototype.api + 'api/local/queryOrderFiles',
      data: order,
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          for (let file of response.data.data) {
            if (file.file_type == 'img') {
              file.url = 'data:image/jpg;base64,' + file.url
            } else if (file.file_type == 'docx') {
              file.url =
                'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' +
                file.url
            } else if (file.file_type == 'doc') {
              file.url = 'data:application/msword;base64,' + file.url
            } else if (file.file_type == 'pdf') {
              file.url = 'data:application/pdf;base64,' + file.url
            } else {
              file.url = 'data:image/jpg;base64,' + file.url
            }
          }
          _this.pageData.orderFileList = response.data.data

          return
        } else if (response.data.code == '404') {
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function getOrderform(_this, orderid, username) {
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/getOrderform',
      url: Vue.prototype.api + 'api/local/getOrderform',
      data: {
        id: orderid,
        username: username,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          _this.pageData.orderform = response.data.data
          _this.pageData.statusId = response.data.data.orderstatus_id
          _this.pageData.orderDetails =
            _this.pageData.orderform.listOrderdetails
          _this.pageData.listOrderRecords = response.data.data.listOrderrecord

          if (!verifyjs.strIsEmpty(response.data.data.fileType)) {
            _this.pageData.resType1 = response.data.data.fileType.split('@@')[0]
            _this.pageData.resType2 = response.data.data.fileType.split('@@')[1]
            _this.pageData.resType3 = response.data.data.fileType.split('@@')[2]
            _this.pageData.resTypeBankslip =
              response.data.data.fileType.split('@@')[3]
          }

          if (_this.pageData.resType1 == 'jpg' || _this.pageData.resType1 == 'png') {
            _this.pageData.isImgPro = true
            _this.pageData.orderform.proformainvoice = _this.pageData.orderform.proformainvoiceUrl
            _this.pageData.proformaInvoiceList.push(
              response.data.data.proformainvoice
            )
          } else {
            _this.pageData.orderform.proformainvoice = _this.pageData.orderform.proformainvoiceUrl
          }

          if (_this.pageData.resTypeBankslip == 'jpg' || _this.pageData.resTypeBankslip == 'png') {
            _this.pageData.isImgBankslip = true
            _this.pageData.orderform.bankslip = _this.pageData.orderform.bankslipUrl
          } else {
            _this.pageData.orderform.bankslip = _this.pageData.orderform.bankslipUrl
          }

          if (_this.pageData.resType2 == 'jpg' || _this.pageData.resType2 == 'png') {
            _this.pageData.isImgPak = true
            _this.pageData.orderform.packinglist = _this.pageData.orderform.packinglistUrl
            _this.pageData.packinglistList.push(response.data.data.packinglist)
          } else {
            _this.pageData.orderform.packinglist = _this.pageData.orderform.packinglistUrl
          }

          if (_this.pageData.resType3 == 'jpg' || _this.pageData.resType3 == 'png') {
            _this.pageData.isImgCom = true
            _this.pageData.orderform.cominvoice = _this.pageData.orderform.cominvoiceUrl
            _this.pageData.cominvoiceList.push(response.data.data.cominvoice)
          } else {
            _this.pageData.orderform.cominvoice = _this.pageData.orderform.cominvoiceUrl
          }

          getAllOrderStatus(_this)

          getOrderFiles(_this, orderid)

          _this.pageData.formFullscreenLoading = false

          return
        } else if (response.data.code == '210') {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })

          _this.pageData.formFullscreenLoading = false
          return
        } else if (response.data.code == '600') {
          _this.$router.push({
            name: 'Login',
          })
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })

          _this.pageData.formFullscreenLoading = false
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })

        _this.pageData.formFullscreenLoading = false
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })

      _this.pageData.formFullscreenLoading = false
      return
    })
}

function getShipping(_this, shippingid) {
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/getShipping',
      url: Vue.prototype.api + 'api/local/getShipping',
      data: {
        shippingaddress: shippingid,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          _this.pageData.shipping = response.data.data

          for (let item of _this.pageData.listCountry) {
            if (_this.pageData.shipping.country === item.id) {
              _this.pageData.shipping.country = item.name_en
            }
          }
        } else if (response.data.code == '210') {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

import Vue from 'vue'
import * as verifyjs from '@/assets/js/verify'

export { getOrderform }



// WEBPACK FOOTER //
// ./src/assets/js/orderform.js